// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDrrapproveIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDrrapproveIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDrrapproveIconOutlined = function DrrpDrrapproveIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDrrapproveIconOutlinedSvg
  }));
};

DrrpDrrapproveIconOutlined.displayName = 'DrrpDrrapproveIconOutlined';
export default React.forwardRef(DrrpDrrapproveIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDrrapproveIconOutlined.js
// module id = 2562
// module chunks = 0